import { Col, Input } from "antd";
import { FormFieldOverrideButton } from "components/Forms/FormFieldsForm/FormFieldOverrideButton";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { FormFieldTypeSelectSearchable } from "components/UI/Selects/FormFieldTypeSelectSearchable/FormFieldTypeSelectSearchable";
import { ReactNode } from "react";
import { FormItem } from "react-hook-form-antd";

interface FormFieldEditorFieldsProps {
    propertyPath: string;
    systemNameDisabled?: boolean;
    sourceLinked?: boolean;
    systemNameSuffix?: ReactNode;
    visibleDescriptionOverride?: InlineOverrideControl;
    placeholderOverride?: InlineOverrideControl;
}

interface InlineOverrideControl {
    available: boolean;
    overridden: boolean;
    onToggle: () => void;
}

const InlineOverrideButton = ({ available, overridden, onToggle }: InlineOverrideControl) => {
    if (!available) return null;

    return <FormFieldOverrideButton overridden={overridden} onToggle={onToggle} className="!-ml-2" />;
};

export const FormFieldEditorFields = ({
    propertyPath,
    systemNameDisabled = false,
    sourceLinked = false,
    systemNameSuffix,
    visibleDescriptionOverride,
    placeholderOverride,
}: FormFieldEditorFieldsProps) => {
    const { control } = useGeneralForm();

    return (
        <>
            <Col span={6}>
                <FormItem control={control} name={`${propertyPath}.system_name`} className="!mb-0">
                    <Input disabled={systemNameDisabled} suffix={systemNameSuffix} />
                </FormItem>
            </Col>
            <Col span={6}>
                <FormItem control={control} name={`${propertyPath}.visible_description`} className="!mb-0">
                    <Input
                        disabled={sourceLinked && !visibleDescriptionOverride?.overridden}
                        prefix={
                            visibleDescriptionOverride?.available ? (
                                <InlineOverrideButton {...visibleDescriptionOverride} />
                            ) : undefined
                        }
                    />
                </FormItem>
            </Col>
            <Col span={5}>
                <FormItem control={control} name={`${propertyPath}.type`} className="!mb-0">
                    <FormFieldTypeSelectSearchable disabled={sourceLinked} />
                </FormItem>
            </Col>
            <Col span={5}>
                <FormItem control={control} name={`${propertyPath}.placeholder`} className="!mb-0">
                    <Input
                        disabled={sourceLinked && !placeholderOverride?.overridden}
                        prefix={
                            placeholderOverride?.available ? (
                                <InlineOverrideButton {...placeholderOverride} />
                            ) : undefined
                        }
                    />
                </FormItem>
            </Col>
        </>
    );
};
